module.exports = __webpack_public_path__ + "static/media/prop-6@2x-thumb.f498d969.webp";